import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable()
export class PermissionManagementService {

    private showMenuSubj: BehaviorSubject<boolean>;
    private userAssignmentsEnabledSubj: BehaviorSubject<boolean>;

    constructor() {
        this.showMenuSubj = new BehaviorSubject<boolean>(true);
        this.userAssignmentsEnabledSubj = new BehaviorSubject<boolean>(false);
    }

    get menuShown(): Observable<boolean> {
        return this.showMenuSubj.asObservable();
    }

    get userAssignmentsEnabled(): Observable<boolean> {
        return this.userAssignmentsEnabledSubj.asObservable();
    }

    showMenu() {
        this.showMenuSubj.next(true);
    }

    hideMenu() {
        this.showMenuSubj.next(false);
    }

    enableUserAssignments() {
        this.userAssignmentsEnabledSubj.next(true);
    }

    disableUserAssignments() {
        this.userAssignmentsEnabledSubj.next(false);
    }
}
